module.exports = __webpack_public_path__ + "img/logo-ctm.26b2b25a.svg";